export default __webpack_public_path__ + "static/media/info.6a666b05.svg";